import {Component} from 'react';
import '../css-files/moneyBuilder.css';
import SavingsPolicyOptions from './datasets/savings_policy_options';
import SavingsTransactionDisplayCard from './savings_transaction_display_card';
import DropDownOptionCard from '../../shared-components/drop_down_option_card';
import { doubleToStringMonthly, standardNumberFormat } from '../../../objects/CommonUse/double_functions';
import reformatDateToDisplay from '../../../objects/CommonUse/reformatDateToDisplay_function';
import calcTotalTranAmts from './objects/calc_total_tran_amts';
import accountTypeOverview from '../text/account_type_overview';

class SavingsTypeTransactionDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false, 
            rerender: false
        };
        this.tranYearOptionsArr = [];
        this.summaryTranArr = [];
        this.savingsTranOut = [];
        this.initializeInformation();
    }

    initializeInformation(){
        this.startYear = this.props.gameDate.split("-")[0];
        this.setHeading();
        this.splitTranInputArr();
    }
     
    setHeading(){
        this.savingsType = this.props.savingsInfo.savingsType;
        const savingsTypeObj = 
            SavingsPolicyOptions.find(elem => elem.type === this.savingsType);
        if (savingsTypeObj){
            this.headingText = savingsTypeObj.longName;
            this.imageURL = savingsTypeObj.imageUrl;
        }
        this.buttonText = 
                accountTypeOverview.find(elem => elem.accountType === this.props.savingsClass).buttonText;
    }
       
    splitTranInputArr(){
        this.level = this.props.savingsInfo.level;
        this.currentPrice = 0;
        if (this.props.savingsClass === "retirement"){
            this.currentPrice = 
                this.props.currentPriceArr.find(elem => elem.retirementType 
                    === this.props.savingsInfo.savingsType).currentPrice;
        }
        this.savingsTranOut = [];
        if (this.level === "summary"){
            this.buildSummaryTranOut();
        }
        if (this.level === "detail"){
           this.buildDetailTranOut();
        }
    }

    buildSummaryTranOut(){
        this.savingsTranArr = JSON.parse(JSON.stringify(this.props.savingsInfo.summaryArr));
        this.savingsTranArr.sort((a, b) => (+a.tranYear + a.tranType > +b.tranYear + a.tranType) ? 1 : -1);
        this.determineFilterOptions();
        this.savingsTranOut = JSON.parse(JSON.stringify(this.savingsTranArr));
        this.filterYear = this.startYear;
        this.filterTransactionHistory(this.filterYear);
        if (this.savingsTranOut.length === 0){
            this.filterYear -= 1;
            this.filterTransactionHistory(this.filterYear);
        }
    }

    buildDetailTranOut(){
        this.savingsType = this.props.savingsInfo.savingsType;
        this.savingsTranArr = JSON.parse(JSON.stringify(this.props.savingsInfo.tranArr));
        this.savingsTranArr.sort((a, b) => 
                    (a.tranDate +  a.tranNbr > b.tranDate + b.tranNbr) ? 1 : -1);
        let totalTranObj =
            calcTotalTranAmts(this.savingsTranArr, this.props.savingsClass);
        this.savingsTranArr = this.savingsTranArr.concat(totalTranObj.yearBreakArr);
        this.savingsTranOut = JSON.parse(JSON.stringify(this.savingsTranArr));
        if (this.savingsTranOut.length > 0){
            this.determineFilterOptions();
            this.filterTransactionHistory(this.startYear);
            if (this.savingsTranOut.length === 0){
                this.startYear -= 1;
                this.filterTransactionHistory(this.startYear);
            }
        }
    }

    determineFilterOptions(){
        let tranYearOptionsArr = [];
        for (let i=0; i<this.savingsTranArr.length; i++){
            let tranYear = "";
            if (this.level === "summary"){
                tranYear = this.savingsTranArr[i].tranYear;
            }else{
                const tranDate = this.savingsTranArr[i].tranDate;
                tranYear = tranDate.split('-')[0];
            }
            const checkTranYearOptions = 
                tranYearOptionsArr.find(elem => elem.value === tranYear)
            if (!checkTranYearOptions && tranYear !== "" ){
                const tranYearObj = {value: tranYear, selection: tranYear};
                tranYearOptionsArr.push(tranYearObj);
            }
        }
        if (this.level === "summary"){
            this.summaryYearOptionsArr = tranYearOptionsArr;
            this.summaryYearOptionsArr.sort((a, b) => (a.value > b.value) ? -1 : 1);
        }else{
            this.tranYearOptionsArr = tranYearOptionsArr;
            this.tranYearOptionsArr.sort((a, b) => (a.value > b.value) ? -1 : 1);
        }
    }   

    filterTransactionHistory(filterYear){
        this.filterYear = filterYear;
        this.balFwdSw = false;
        if (this.level === "summary"){
            this.savingsTranOut = this.savingsTranArr.filter(item => +item.tranYear === +this.filterYear);
            this.savingsTranOut.sort((a, b) => (+a.tranSort + +a.tranNbr > +b.tranSort + +b.tranNbr) ? 1 : -1);
            let savingsTranObj = this.savingsTranArr.find(elem => elem.balFwdSw === true);
            if (savingsTranObj){
                this.balFwdSw = true;
            }
        }else{
            this.savingsTranOut = this.savingsTranArr.filter(item => +item.tranDate.split("-")[0] 
                === +this.filterYear);
            this.savingsTranOut.sort((a, b) => 
                (a.tranDate +  +a.tranNbr > b.tranDate + +b.tranNbr) ? 1 : -1);
            let savingsTranObj = this.savingsTranArr.find(elem => elem.tranType === "Balance Forward");
            if (savingsTranObj){
                this.balFwdSw = true;
            }
        }
        this.setState({rerender: !this.state.rerender})
      
    }

    render() {
        if (this.level === "summary"){
             this.summaryYearOptions = this.summaryYearOptionsArr.map((optionsList,index) =>
                <DropDownOptionCard options={optionsList} key={index} />
            );
        }else{
            this.yearOptions = this.tranYearOptionsArr.map((optionsList,index) =>
                <DropDownOptionCard options={optionsList} key={index} />
            );
        }
    
        this.summaryTransactionInfo =  this.savingsTranOut.map((transactions, index) =>
            <SavingsTransactionDisplayCard key={index} tranInfo={transactions} 
                     displayType={this.level}
                     savingsClass={this.props.savingsClass}
                 />
        );
        const defaultImgSrc = "./assets/Savings/" + this.imageURL;
    return <>
        <div>
        {this.props.savingsInfo.level === "summary" ?
            <>
                <div className="row">
                    <div className="col-sm-2"></div>
                    <div className="col-sm-6 text-center ml-5">
                        <h5>Summary for {this.headingText}</h5>
                    </div>
                    <div className="col-sm-3 text-right">
                        <label className="filter-label" htmlFor="investYear">
                            Tran Year:&nbsp;
                        </label>
                        <select
                            id="investYear"
                            onChange={(val) => this.filterTransactionHistory(val.target.value)}
                            className="filter-select small-select"
                        >
                        {this.summaryYearOptions}
                        </select>
                    </div>
                </div>
                    <div className="row mb-4">
                        <div className="col-sm-2">
                            <img src={defaultImgSrc} className="card_size_thumbnail_img" alt="logo"/>
                        </div>
                        <div className="col-sm-9">
                            <table className="table table-hover table-no-space table-borderless invest-type-text">
                                <tbody>
                                    <tr>
                                        <th className="text-center">
                                            Tran Type
                                        </th>
                                        <th className="text-center">
                                            Tran Year
                                        </th>
                                        {this.props.savingsClass === "retirement"  ?
                                            <>
                                                <th className="text-center">
                                                    Share Quantity
                                                </th>
                                            </>
                                        :
                                            null
                                        }
                                        <th className="text-center">
                                            Tran Amount
                                        </th>
                                    </tr>
                                    {this.summaryTransactionInfo}
                                </tbody>
                            </table>
                        </div>
                        {this.balFwdSw  ?
                            <h6 className="mx-5">
                                These transactions show a summary of your account activity through &nbsp;
                                {this.filterYear}. Older transactions have been grouped together into a 
                                single balance forward total.
                            </h6>
                        :
                            null
                        }
                        <div className="col-sm-2"></div>
                    </div>
            </>
        :
            <>
                <div className="mt-4 solid-line"></div>
                <h5 className="text-center">Detail Transactions for {this.headingText}</h5>
                <div className="text-left mx-4 invest-type-text">{this.informationText}</div>
                <div className="row">
                    <div className="col-sm-2">
                        <img src={defaultImgSrc} className="card_size_thumbnail_img" alt="logo"/>
                    </div>
                    <div className="col-sm-10">
                        <div className="row">
                            <div className="col-sm-5">
                                <b>Date Account Opened: </b>
                                    {reformatDateToDisplay(this.props.savingsInfo.startDate)}
                            </div>
                            <div className="col-sm-5">
                                <b>Current Game Date: </b>
                                    {reformatDateToDisplay(this.props.gameDate)}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-5">
                                {this.props.savingsClass === "bank"  ?
                                    <>
                                        <span className="font-weight-bold">Current Int Rate: </span>
                                        <span className="">
                                            {standardNumberFormat(this.props.savingsInfo.interestRate)}%
                                        </span>
                                    </>
                                :
                                     <>
                                        <span className="font-weight-bold">Company Match Rate: </span>
                                        <span className="">
                                            {standardNumberFormat(this.props.companyMatchRate)}%
                                        </span>
                                    </>
                            }
                            </div>
                             <div className="col-sm-5 text-left"><b>Monthly Savings Amt: </b>
                                    {doubleToStringMonthly(this.props.savingsInfo.monthlyDepositAmt)}
                            </div>
                        </div>
                        <div className="text-right mr-4">
                            <label className="filter-label" htmlFor="investYear">
                                Transaction Year:&nbsp;
                            </label>
                            <select
                                id="investYear"
                                onChange={(val) => this.filterTransactionHistory(val.target.value)}
                                className="filter-select small-select"
                            >
                            {this.yearOptions}
                            </select>
                        </div>
                        <div className="row">
                            <div className="col-sm-10">
                                <table className={this.tableClass}>
                                    <tbody>
                                        <tr>
                                            <th className="text-center">Tran Type</th>
                                            <th className="text-center">Tran Date</th>
                                            {this.props.savingsClass === "retirement"  ?
                                                <>
                                                    <th className="text-center">
                                                        Share Quantity
                                                    </th>
                                                     <th className="text-cente">
                                                        Share Price
                                                    </th>
                                                </>
                                            :
                                                null
                                            }
                                            <th className="text-center">Tran Amount</th>
                                        </tr>
                                            {this.summaryTransactionInfo}
                                    </tbody>
                                </table>
                            </div>
                            {this.balFwdSw  ?
                                <h6 className="mx-5">
                                    The balance forward transaction is a summary of your account activity through &nbsp;
                                    {this.filterYear}. Older transactions have been grouped together into  
                                    this single transaction.
                                </h6>
                            :
                                null
                            }
                        </div>
                    </div>
                </div>
                    
                <div className= "mx-4 mt-4">
                    <b>Click on the "{this.buttonText}" button to the right</b> if you wish 
                    to make a change to the amount in one of your savings accounts.
                </div>
            </>
        }
        </div>
            
    </>
    }
}
export default SavingsTypeTransactionDisplay;